module.exports = __webpack_public_path__ + "img/pic5.a3a745ec.png";